import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import DemoRequestModal from '@/components/DemoRequestModal';

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="w-full pt-16">
        <div className="container mx-auto px-5 lg:px-0">
          <div className="w-full lg:w-3xl mx-auto mb-12">
            <h1 className="text-2xl md:text-5xl text-text-primary font-bold text-center mb-2 md:mb-6">
              Simplify resident & property management in one platform
            </h1>
            <p className="text-base md:text-2xl text-text-secondary text-center mb-8">
              Manage residents, payments, announcements, and reports all from a
              single dashboard.
            </p>

            <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-7">
              <Link to="/sign-in">
                <button className="text-sm md:text-lg text-white font-bold bg-[#5761EB] px-3 md:px-6 py-2 md:py-3 rounded-lg hover:bg-[#4651DB] transition-colors">
                  Get Started Free
                </button>
              </Link>
              <button
                onClick={() => setIsModalOpen(true)}
                className="text-sm md:text-lg bg-white font-bold text-[#5761EB] px-3 md:px-6 py-2 md:py-3 rounded-lg hover:bg-gray-50 transition-colors border-2 border-[#5761EB]"
              >
                Book a demo
              </button>
            </div>
          </div>
          <div>
            <div className="w-full lg:max-w-[65%] mx-auto">
              <img
                src="/assets/images/home/hero-image.png"
                alt="sobar house"
                className="w-full"
                fetchPriority="high"
                width="701"
                height="467"
              />
            </div>
          </div>
        </div>
      </div>

      <DemoRequestModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Hero;

